import api from './api';
import { metricsActions } from '../redux/actions';
import {
  setLastEntriesError,
  setLastEntriesLoading,
  setSensorMetrics,
  setSensorMetricsError,
  setSensorMetricsLoading
} from '../redux/actions/metricsActions';
import { findTimeSinceLastReading } from '../utils/sensorHelpers';

const getSensorData = (systemId, sensorId, fromDate, toDate) => {
  const url = `/api/v1/metrics/${systemId}/${sensorId}?from=${fromDate}&to=${toDate}`;
  return api.get(url);
};

export const getSensorDataFromTimePreset = (
  systemId,
  sensorId,
  timePreset,
  fromDate,
  toDate
) => {
  fromDate = fromDate.toUTCString();
  toDate = toDate.toUTCString();
  return (dispatch) => {
    dispatch(setSensorMetricsLoading(sensorId, timePreset));
    getSensorData(systemId, sensorId, fromDate, toDate)
      .then((metrics) => {
        metrics.deviceSensorId = sensorId;
        dispatch(setSensorMetrics(metrics, sensorId, timePreset));
      })
      .catch((e) => {
        console.error(e);
        dispatch(setSensorMetricsError(sensorId, timePreset));
      });
  };
};

export const getLastEntries = (systemId) => {
  return (dispatch, getState) => {
    dispatch(setLastEntriesLoading(systemId));
    api
      .get(`/api/v1/metrics/${systemId}/last-entries`)
      .then((lastEntries) => {
        const timeSinceLastReading = findTimeSinceLastReading(lastEntries);
        const systemSensorsWhoNeedDescriptiveNames = ['Voltage'];
        const systemSensorIds = getState().bessReducer.details[
          systemId
        ].sensors.map((sensor) => sensor.deviceSensorId);
        lastEntries = lastEntries.map((metric) => {
          if (
            systemSensorIds.includes(metric.deviceSensorId) &&
            systemSensorsWhoNeedDescriptiveNames.includes(metric.sensorType)
          ) {
            return { ...metric, sensorType: 'System' + metric.sensorType };
          }
          return metric;
        });
        dispatch(
          metricsActions.setLastEntries(
            lastEntries,
            timeSinceLastReading,
            systemId
          )
        );
      })
      .catch((e) => {
        console.error(e);
        dispatch(setLastEntriesError(systemId));
      });
  };
};
